<template>
<div>

<navbar></navbar>

  <div class="blocco row h100" style="justify-content: flex-start;">

    <div class="grid h100 nav2">
    <div class="spacer xs"></div>
    <template>
        <el-select v-model="value" placeholder="Jahr auswählen">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </template>

      <div class="spacer xs"></div>

      <template>
        <el-select v-model="size" placeholder="Grösse auswählen">
          <el-option
            v-for="item in sizes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </template>
      <div class="spacer xs"></div>
      <p v-if="value"><strong><a class="btn btn-block btn-green" href="#" v-on:click="getHouses()">Kennzahlen anzeigen</a></strong></p>

<template>
  <el-select v-model="selectedhouses" multiple filterable placeholder="Select">
    <el-option
      v-for="item in houselist"
      :key="item._id"
      :label="item.struktur"
      :value="item._id">
    </el-option>
  </el-select>
  

</template>
<div class="spacer xs"></div>

<p v-if="selectedhouses"><strong><a class="btn btn-block btn-green" href="#" v-on:click="filterHouses()">Kennzahlen filtern</a></strong></p>

    </div>


    <div class="grid h100 w80 innercontent">
    <!-- {{houseratio}} -->
    <!-- {{selectedhouses}} -->
    <!-- {{houses}} -->
    <!-- {{houseratio['5703bfe7ef1c3574161f7f90']['6']['val']}} - {{houseratio['5703bfe7ef1c3574161f7f90']['6']['euro']}} - {{houseratio['5703bfe7ef1c3574161f7f90']['6']['perc']}} -->
    <!-- {{ratioquestsordered}} -->

<!-- <template>
  <el-table
    :data="ratioquestsordered"
    style="width: 100%"
    height="1400">
    <el-table-column
      fixed
      prop="nr"
      label="Nr"
      width="30">
    </el-table-column>
    <el-table-column
      prop="quest"
      label="Kennzahl"
      width="300">
    </el-table-column>
    <el-table-column
      prop="quest"
      label="Kennzahl"
      width="300">
    </el-table-column>
    <el-table-column
    v-for="house in houses"
      prop=""
      label="house.struktur"
      width="300">{{houseratio[house._id][ratioquest.nr]['perc']}}
    </el-table-column>
  </el-table>
</template> -->

  <div class="spacer xs"></div>

  <!-- {{houseratio['593e5c9f5f43221c04483817']['1']['perc']}} -->

  <el-table
    :data="ratioquestsordered"
    height="auto"
    stripe
    style="width: 100%">
    <el-table-column
      fixed
      prop="quest"
      label="Frage"
      width="360">
    </el-table-column>
    <el-table-column
      prop="nr"
      label="Nr"
      width="48">
    </el-table-column>
    <el-table-column
      v-for="(house, index) in houses"
      :key="index"
      :prop="house._id"
      :label="house.struktur"
      width="360">
      <template slot-scope="scope">
        <!-- <span style="margin-left: 10px">{{ houseratio[scope.column.property][scope.row.nr] }}</span> -->
        
          <el-tag type="" v-if="houseratio[scope.column.property][scope.row.nr]">{{houseratio[scope.column.property][scope.row.nr]['val']}}</el-tag>
          <el-tag type="" v-if="houseratio[scope.column.property][scope.row.nr]">{{houseratio[scope.column.property][scope.row.nr]['perc']}} %</el-tag>
          <el-tag type="" v-if="houseratio[scope.column.property][scope.row.nr]">{{houseratio[scope.column.property][scope.row.nr]['euro']}} €</el-tag>
        
      </template>
    </el-table-column>
  </el-table>

    <circle4 v-if="loading"></circle4>
    <!-- <p>{{houseratio}}</p> -->
<!--       <table class= "table table-striped" v-if="ratioquestsordered">
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th colspan="3"  v-for="house in houses">{{house.struktur}}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="ratioquest in ratioquestsordered" >
          <td>{{ratioquest.nr}}</td>
          <td>{{ratioquest.quest}}</td>
          <td colspan="3" v-for="house in houses">
          <table>
            <tr>
              <td>
                <span v-if="houseratio[house._id][ratioquest.nr]"><span v-if="houseratio[house._id][ratioquest.nr]['val']">{{houseratio[house._id][ratioquest.nr]['val']}}</span></span>
              </td>
              <td>
                <span v-if="houseratio[house._id][ratioquest.nr]"><span v-if="houseratio[house._id][ratioquest.nr]['perc']">{{houseratio[house._id][ratioquest.nr]['perc']}}%</span></span>
              </td>
              <td>
                <span v-if="houseratio[house._id][ratioquest.nr]"><span v-if="houseratio[house._id][ratioquest.nr]['euro']">{{houseratio[house._id][ratioquest.nr]['euro']}}€</span></span>
              </td>
            </tr>
          </table>
          
          </td>
        </tr>
        </tbody>
      </table> -->

      <!-- <p v-for="ratioquest in ratioquestsordered">{{ratioquest}}</p> -->

      <div class="spacer xs"></div>

    </div>

  </div>

</div>
</template>

<script>
  import Navbar from '@/components/Navbar'
  import {Circle4} from 'vue-loading-spinner'
  import _ from 'lodash'
  // var host = 'https://bench.node.systems'
  // var host = 'http://localhost'
  var host = process.env.ROOT_HOST
  export default {
    name: 'ratios',
    // extends: Bar,
    props: ['cat', 'chartId', 'data', 'house'],
    // props: {
    //   house: Object
    // },
    data () {
      return {
        loading: false,
        profile: JSON.parse(localStorage.profile),
        houses: '',
        houselist: '',
        rat: null,
        ratioquests: '',
        selectedhouse: '',
        selectedhouses: [],
        options: [{
          value: '2023',
          label: '2023'
        }, {
          value: '2022',
          label: '2022'
        }, {
          value: '2021',
          label: '2021'
        }, {
          value: '2020',
          label: '2020'
        }, {
          value: '2019',
          label: '2019'
        }, {
          value: '2018',
          label: '2018'
        }, {
          value: '2017',
          label: '2017'
        }, {
          value: '2016',
          label: '2016'
        }, {
          value: '2015',
          label: '2015'
        }, {
          value: '2014',
          label: '2014'
        }],
        sizes: [{
          value: 'klein',
          label: 'klein'
        }, {
          value: 'mittel',
          label: 'mittel'
        }, {
          value: 'gross',
          label: 'gross'
        }],
        value: '2017',
        size: '',
        quests: '',
        houseratio: {}
      }
    },
    components: {
      Circle4,
      Navbar
    },
    methods: {
      housedata (row, col, cell, index) {
        // console.log('housedata: ', row.nr, col.property)
        // col.forEach((cols, index) => {
        //   console.log(cols)
        // })
        // console.log(col.property, this.houseratio[col.property][row.nr])
        // if (this.houseratio[col.property][row.nr]) {
        //   return this.houseratio[col.property][row.nr]['perc']
        // } else {
        //   return 1
        // }
        // return this.houseratio[col.property]['1']['perc']
      },
      filterHouses: function () {
        // console.log(this.value)
        this.loading = true
        this.houses = []
        // this.houselist.filter(function(item){
        //   if (this.selectedhouses.includes(item._id)) {
        //     console.log(item)
        //   }
        // })
        this.houselist.forEach((house, index) => {
          if (this.selectedhouses.includes(house._id)) {
            console.log(house)
            this.houses.push(house)
          }
        })
        this.loading = false
      },
      getHouses: function () {
        // console.log(this.value)
        this.loading = true
        // this.houseratio = {}
        this.$http
          .get(host + ':44534/api/houses/' + this.size,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            this.houses = data.body.houses
            // console.log(this.houses)
            data.body.houses.forEach((house, index) => {
              // this.houseratio.push(house._id)
              this.$set(this.houseratio, house._id, {})
            })
            this.loading = false
            this.getRatios()
            // this.getRatioquests()
          }, (error) => {
            console.log(error)
          })
      },
      getHousesall: function () {
        // console.log(this.value)
        this.loading = true
        this.$http
          .get(host + ':44534/api/houses',
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            this.houses = data.body.houses
            this.houselist = data.body.houses
            // console.log(this.houses)
            data.body.houses.forEach((house, index) => {
              // this.houseratio.push(house._id)
              this.$set(this.houseratio, house._id, {})
            })
            this.loading = false
            // this.getRatios()
            // this.getRatioquests()
          }, (error) => {
            console.log(error)
          })
      },
      getRatios: function () {
        console.log(this.value)
        this.loading = true
        this.$http
          .get(host + ':44534/api/ratios/year/' + this.value,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            // this.houses = data.body.houses
            console.log(data.body.ratioquests)
            data.body.ratioquests.forEach((ratio, index) => {
              // var struktur = ratio.struktur
              // this.houseratio[ratio.struktur].push({ratio.nr : {}})
              // console.log(ratio)
              this.$set(this.houseratio[ratio.struktur], ratio.nr, {val: ratio.ratioval, euro: ratio.ratioeur, perc: ratio.ratioperc})
            })
            this.getRatioquests()
            // this.loading = false
          }, (error) => {
            console.log(error)
          })
      },
      getRatioquests: function () {
        this.loading = true
        this.$http
          .get(host + ':44534/api/ratiosquests',
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            console.log(data.body.ratio)
            this.quests = data.body.ratio
            data.body.ratio.forEach((house, index) => {
              // this.houseratio[ratio.struktur].push(ratio.nr)
              // this.$set(this.houseratio, house.struktur, house.nr)
            })
            this.loading = false
          }, (error) => {
            console.log(error)
          })
      }
    },
    beforeMount () {
      this.getHousesall()
      // this.getRatioquests()
    },
    computed: {
      ratioquestsordered: function () {
        return _.orderBy(this.quests, 'nr')
      }
      // housesgrouped: function () {
      //   return _.groupBy(this.houses, 'size')
      // }
    },
    mounted () {
    },
    created () {
      // this.calcratio()
    }
  }
</script>

<style>
  a {
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// src/components/Compare.vue